import React from "react";
import { Phone, EnvelopeSimple } from "@phosphor-icons/react";

const pill = (preferred) =>
  `inline-flex items-center gap-1.5 text-sm rounded-full px-3 py-1.5 border transition-colors hover:border-[#73bf44] hover:text-[#73bf44] max-w-full ${preferred ? "text-white bg-[#73bf44]/[0.08] border-[#73bf44]/40" : "text-neutral-400 bg-white/[0.03] border-neutral-800"}`;

export function TicketContact({ t }) {
  const method = t.contact_method || "phone";
  return (
    <div className="space-y-1.5" data-testid="ticket-contact">
      <div className="text-[0.6rem] uppercase tracking-[0.18em] font-bold text-neutral-500" data-testid="ticket-contact-preference">
        Prefers {method === "email" ? "email" : "a phone call"}
      </div>
      <div className="flex flex-col items-start gap-1.5">
        {t.phone && (
          <a href={`tel:${t.phone.replace(/[^\d+]/g, "")}`} data-testid="ticket-call-phone-btn" className={pill(method === "phone")}>
            <Phone size={14} weight="fill" className="shrink-0" /> {t.phone}
          </a>
        )}
        {t.email && (
          <a href={`mailto:${t.email}?subject=${encodeURIComponent(`${t.reference} · On The Move technical support`)}`} data-testid="ticket-email-btn" className={pill(method === "email")}>
            <EnvelopeSimple size={14} weight="fill" className="shrink-0" /> <span className="truncate">{t.email}</span>
          </a>
        )}
      </div>
    </div>
  );
}
